/* eslint-disable react/react-in-jsx-scope */
import { Box, Button, useMantineColorScheme } from '@mantine/core';
// import { X } from 'tabler-icons-react';

const NewRangePopoverContent = ({
  children,
  onConfirm,
  onClear,
  // onClose,
  confirmLabel = 'Confirm',
  clearLabel = 'Clear',
  // disableConfirm = false,
}) => {
  const { colorScheme } = useMantineColorScheme();
  return (
    <Box
      p="md"
      bg="white"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '26px',
        position: 'relative',
        backgroundColor: colorScheme === 'dark' ? '#1a1b1e' : '#fff',
      }}
    >
      {/* Close icon in top-right corner
      {onClose && (
        <Box
          className="cursor-pointer absolute -top-2 -right-5"
          onClick={onClose}
        >
          <X size={18} color="#898989" />
        </Box>
      )} */}

      <Box style={{ display: 'flex', gap: '8px' }}>
        {children}
      </Box>

      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: '4px',
        }}
      >
        <Button className="dark:text-black text-inherit" variant={colorScheme === 'dark' ? '' : 'subtle'} radius="md" color="gray" onClick={onClear}>
          {clearLabel}
        </Button>
        <Button className="bg-[#33B1FF]" onClick={onConfirm} color="blue" radius="md">
          {confirmLabel}
        </Button>
      </Box>
    </Box>
  );
};

export default NewRangePopoverContent;
